/**
 * Triggers the animated squiggle/underline stroke on `.highlighted-text`
 * elements the first time they scroll into view. Runs once per element.
 */
(function () {
  var elements = document.querySelectorAll('.highlighted-text');
  if (!elements.length) return;

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    elements.forEach(function (el) {
      el.classList.add('animate');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.4 }
  );

  elements.forEach(function (el) {
    observer.observe(el);
  });
})();
